import {useMemo} from 'react';
import {useLocation} from 'react-router-dom';

export default function useUriIsSelected(uri: string): boolean {
  const location = useLocation();
  return useMemo(() => (location.pathname + location.hash + location.search).startsWith(uri), [uri, location]);
}
